/* eslint-disable @typescript-eslint/no-explicit-any */

export const pushDataLayer = <T extends Record<string, any>>(event: string, data: T) => {
  const timestamp = new Date().getTime().toString();

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    ...data,
    timestamp,
  });
};

export const createUndefinedObject = <T extends Record<string, any>>() => {
  return new Proxy({} as { [K in keyof T]: undefined }, {
    get: () => undefined,
  });
};

export const getTimestamp = (startDate: number, endDate: number) => {
  return Math.abs((endDate - startDate) / 1000);
};
